// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3598":"532504cc","8231":"532504cc"}[chunkId] + ".chunk.css";
};